import { DocumentData } from "@angular/fire/firestore";
import { User } from "./user.model";
import { AdminBuilder } from "./admin.builder";
import * as firebase from "firebase";
import { AuthType } from "../models/enums/auth-type.enum";
export class UserBuilder {
  public id: string;
  public admin: AdminBuilder;
  public birthday: string;
  public createdAt: firebase.firestore.Timestamp;
  public customerId: string;
  public email: string;
  public lastLoggedIn: firebase.firestore.Timestamp;
  public name: string;
  public phone: string;
  public image: string;
  public referredBy: string;
  constructor() {
    this.admin = new AdminBuilder();
  }
  get description(): string {
    return this.admin.description;
  }

  setEmail(email: string): UserBuilder {
    this.email = email;
    return this;
  }
  setName(name: string): UserBuilder {
    this.name = name;
    return this;
  }
  setPhone(phone: string): UserBuilder {
    this.phone = phone;
    return this;
  }
  setCreatedBy(createdBy: string): UserBuilder {
    this.admin.createdBy = createdBy;
    return this;
  }
  setEditedBy(editedBy: string): UserBuilder {
    this.admin.editedBy = editedBy;
    return this;
  }
  setType(type: AuthType): UserBuilder {
    this.admin.type = type;
    return this;
  }
  setCities(cities: string[]): UserBuilder {
    this.admin.cities = cities;
    return this;
  }
  setVenues(venues: string[]): UserBuilder {
    this.admin.venues = venues;
    return this;
  }
  setAccess(hasFullAccess: boolean): UserBuilder {
    this.admin.hasFullAccess = hasFullAccess;
    return this;
  }
  setCreatedAt(): UserBuilder {
    this.createdAt = firebase.firestore.Timestamp.now();
    return this;
  }
  setDescription(description: string): UserBuilder {
    this.admin.description = description;
    return this;
  }

  build(): User {
    return new User(this);
  }

  edit(user: User): UserBuilder {
    this.id = user.id;
    this.admin = new AdminBuilder().edit(user.admin);
    this.createdAt = firebase.firestore.Timestamp.fromDate(user.createdAt);
    this.email = user.email;
    this.lastLoggedIn =
      user.lastLoggedIn == null
        ? null
        : firebase.firestore.Timestamp.fromDate(user.lastLoggedIn);
    this.phone = user.phone;
    this.name = user.name;
    return this;
  }

  load(data: DocumentData): UserBuilder {
    this.id = data.id;
    this.admin = new AdminBuilder().load(data.admin);
    this.createdAt = new firebase.firestore.Timestamp(
      data.createdAt._seconds,
      data.createdAt._nanoseconds
    );
    this.email = data.email;
    this.phone = data.phone;
    this.name = data.name;
    this.lastLoggedIn =
      data.lastLoggedIn == null
        ? null
        : new firebase.firestore.Timestamp(
            data.lastLoggedIn._seconds,
            data.lastLoggedIn._nanoseconds
          );
    return this;
  }
}
